import { CarParkPlanBooking, CarParkSpace } from '@features/whereabouts/services/CarParkingPlanService';
import { useMemo } from "react";
import { SideOfDay } from '@features/whereabouts/models/movements.models';
import { User } from '@shared/models/user.models';
import { isCompanyAdminUser, isOfficeAdminUser } from "@shared/utils/AccessControl";

export function WithParkingSpaceBooking(carParkBookings: CarParkPlanBooking[], carParkingSpace?: CarParkSpace) {

  const bookings: CarParkPlanBooking[] = useMemo(() => {
    return carParkBookings.filter(b => b.spaceId === carParkingSpace?.id);
  }, [carParkBookings, carParkingSpace?.id]);

  const amBooking = useMemo(() => {
    const am = bookings.find(b => b.sideOfDay === SideOfDay.AM);
    if (am) {
      return {
        name: `${am.firstName} ${am.lastName}`,
        firstName: am.firstName,
        lastName: am.lastName,
        jobTitle: am.jobTitle,
        label: am.label,
        userId: am.userId,
      }
    }
  }, [bookings]);

  const pmBooking = useMemo(() => {
    const pm = bookings.find(b => b.sideOfDay === SideOfDay.PM);
    if (pm) {
      return {
        name: `${pm.firstName} ${pm.lastName}`,
        firstName: pm.firstName,
        lastName: pm.lastName,
        jobTitle: pm.jobTitle,
        label: pm.label,
        userId: pm.userId,
      }
    }
  }, [bookings]);

  const allDayBooking = useMemo(() => {
    const allDay = bookings.find(b => b.sideOfDay === SideOfDay.AllDay);
    if (allDay) {
      return {
        name: `${allDay.firstName} ${allDay.lastName}`,
        firstName: allDay.firstName,
        lastName: allDay.lastName,
        jobTitle: allDay.jobTitle,
        label: allDay.label,
        userId: allDay.userId,
      }
    }
  }, [bookings]);

  const isBooked = useMemo(() => {
    return bookings.length > 0;
  }, [bookings.length]);

  function canControlBooking(user?: User, sideOfDay?: SideOfDay) {
    if (user && isBooked) {
      if (isCompanyAdminUser(user) || isOfficeAdminUser()) {
        return true;
      }
      return !!bookings.find(b => b.userId === user.id && (b.sideOfDay === SideOfDay.AllDay || b.sideOfDay === sideOfDay));
    }
    return false;
  }

  return {
    bookings,
    amBooking,
    pmBooking,
    allDayBooking,
    isBooked,
    canControlBooking,
  }
}
